<template>
  <div class='EnbItemImg02'>
    <div class="sold-out" v-if="data.gerEstoque && data.estoque <= 0 && data.tipo !== 'Variável'">Esgotado</div>
    <img v-if="data.img.length" :src="api + data.img[0].img">
    <img-icon
    v-if="!data.img.length"
    :options="{ width: '180px', height: '150px', color: '#CCCCCC', action: false }"
    />
  </div>
</template>

<script>
import ImgIcon from '@/components/EnbPainel/Icons/ImgIcon'
import api from '@/mixins/api'
export default {
  name: 'EnbItemImg02',
  components: { ImgIcon },
  props: ['data'],
  mixins: [api]
}
</script>

<style scoped>
.EnbItemImg02 {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: #FFFFFF;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.2s;
}

img:hover {
  transform: scale(1.08);
}

.sold-out {
  font-size: 10px;
  position: absolute;
  top: 5%;
  color: #FFFFFF;
  padding: 1%;
  background-color: red;
  border-radius: 5px;
  border: 2px solid #FFFFFF;
  z-index: 1;
}
</style>
